import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/outline';
import { useCopyToClipboard } from 'usehooks-ts';
import { Address } from 'viem';
import { useDisconnect } from 'wagmi';
import { CopyIcon } from '../../assets/icons';
import { truncateAddress } from '../../lib/stringHelpers';
import { Button, ButtonSize } from '../catalyst-ui-kit/button';
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '../catalyst-ui-kit/dropdown';

type ConnectedWalletDropdownProps = {
  address: Address;
  ensName?: string;
  size?: ButtonSize;
  className?: string;
};

export function ConnectedWalletDropdown({
  size,
  address,
  ensName,
  className,
}: ConnectedWalletDropdownProps) {
  const { disconnect } = useDisconnect();
  const [, copyToClipboard] = useCopyToClipboard();

  const truncatedAddress = truncateAddress(address);

  const handleCopy = () => {
    copyToClipboard(address).catch(console.error);
  };

  const handleDisconnect = () => {
    disconnect();
  };

  return (
    <Dropdown>
      <DropdownButton as={Button} size={size} color="tertiary" className={className}>
        {ensName || truncatedAddress}
      </DropdownButton>
      <DropdownMenu anchor="bottom end">
        <DropdownItem className="flex justify-between" onClick={handleCopy}>
          {truncatedAddress}
          <CopyIcon className="size-4 text-contentSecondary" />
        </DropdownItem>
        <DropdownItem className="flex justify-between" onClick={handleDisconnect}>
          Disconnect
          <ArrowRightStartOnRectangleIcon className="!m-0 size-4 !text-contentSecondary" />
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
